import { PickerRequest } from '../entities/pickers/picker.response';
import { TaskTarget } from './task.enum';

export const TaskAssigneePickerVariant = 'taskAssignee';

export interface PickerTaskAssigneeRequest extends PickerRequest {
    variant: typeof TaskAssigneePickerVariant;
    /** The task's stage id; absent for a task on a job, opportunity or site. */
    parentId?: string;
    /** Absent reads as Field, as the legacy task editor assumed. */
    target?: TaskTarget;
}

/** Target is the raw form value, so anything outside the enum is dropped and the server falls back to Field. */
export function taskAssigneePickerRequest(stageId: string | undefined, target: unknown): PickerTaskAssigneeRequest {

    return {
        variant: TaskAssigneePickerVariant,
        parentId: stageId,
        target: Object.values(TaskTarget).find(value => value === target),
    };
}
